<template>
  <v-dialog
    max-width="600px"
    v-model="dialog"
    persistent
    @keydown.enter.prevent="save"
  >
    <v-card>
      <v-card-title/>
      <v-card-text>
        <v-row dense>
          <v-autocomplete
              v-model="model"
              :items="values"
              item-text="name"
              item-value="id"
              label="Select"
              hide-details
              return-object
              multiple
              small-chips
              deletable-chips
          />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {CardPackageModel} from "@/modules/redactor/models/card-package/CardPackageModel";

export default {
  name: "r-card-package-dropdown-dialog",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: [],
    rules: ViewRules.READONLY,
  }),
  computed: {
    values() {
      return RedactorUtils.getCardPackages();
    }
  },
  methods: {
    show(rules, inc) {
      this.dialog = true;
      this.rules = rules;
      this.model = this.toModels(inc);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    toModels(v) {
      const arr = Array.isArray(v) ? v : (v != null ? [v] : []);
      return arr
        .map(i => {
          if (i instanceof CardPackageModel) return i;

          if (typeof i === "string" && i.length === 32) return RedactorUtils.getCardPackage(i);

          return null;
        })
        .filter(Boolean);
    },

    save() {
      const list = Array.isArray(this.model) ? this.model : [];
      const isValid =
        list.length > 0 &&
        list.every(i => i && typeof i.valid === 'function' && i.valid());

      if (!isValid) {
        this.$alert("Invalid config!");
        return;
      }

      const ids = list.map(i => i.uid ?? i.id).filter(Boolean);

      this.resolve(ids);
      this.discard();
    },

    cancel() {
      this.reject();
      this.discard();
    },

    discard() {
      this.dialog = false;
    }
  }
}
</script>
